import React from 'react';

export default class ShareCheckboxes extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checkboxes: [
                {
                    name: 'name',
                    value: false,
                    title: 'Name'
                },
                {
                    name: 'skills',
                    value: false,
                    title: 'Skills'
                },
                {
                    name: 'videoAndAudio',
                    value: false,
                    title: 'Media Files'
                },
                {
                    name: 'contactDetails',
                    value: false,
                    title: 'Contact Details'
                },
                {
                    name: 'credits',
                    value: false,
                    title: 'Credits (5 most recent)'
                }
            ],
            all: true
        };
    }

    componentDidMount() {
        if (this.props.agentSite) {
            let checkboxes = this.state.checkboxes;
            checkboxes.push({
                name: 'agentDetails',
                value: false,
                title: 'Agent Details'
            });
            this.setState({checkboxes});
        }

        this.markAll(true);
    }

    markAll(checked) {
        let checkboxes = this.state.checkboxes.map((checkbox) => {
            checkbox.value = checked;
            return checkbox;
        });
        this.setState({checkboxes, all: checked}, () => {
            if (this.props.onChange) {
                this.props.onChange(this.state.checkboxes);
            }
        });
    }

    handleChange(name, checked) {
        let checkboxes = this.state.checkboxes.map((checkbox) => {
            if (checkbox.name === name) {
                checkbox.value = checked;
            }
            return checkbox;
        });
        this.setState({checkboxes}, () => {
            if (this.props.onChange) {
                this.props.onChange(this.state.checkboxes);
            }
        });
    }

    render() {
        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    <label className="custom-control custom-checkbox">
                        <input onChange={(e) => this.markAll(e.target.checked)} type="checkbox" className="custom-control-input" checked={this.state.all}/>
                        <span className="custom-control-indicator"></span>
                        <span className="custom-control-description">Select/Unselect All</span>
                    </label>
                </div>
                {this.state.checkboxes.map((checkbox, index) => {
                    return (
                        <div key={index} className="col-12 col-md-6">
                            <label className="custom-control custom-checkbox">
                                <input onChange={(e) => this.handleChange(checkbox.name, e.target.checked)} type="checkbox" className="custom-control-input" checked={checkbox.value}/>
                                <span className="custom-control-indicator"></span>
                                <span className="custom-control-description">{checkbox.title}</span>
                            </label>
                        </div>
                    );
                })}
            </div>
        );
    }
}